import axios from "axios";
import { RSAEncryption } from "../util/Cryptography";

import type { AuthUserAPIResponse } from "../shared/interface/auth/User.interface";
import type { CommonMessageInterface, RefreshTokenAPIInterface } from "../shared/interface/UserManagement/user.interface";

export const signIn = async (username: string, password: string) => {
  try {
    const encryptedUsername = RSAEncryption.encrypt(username);
    const encryptedPassword = RSAEncryption.encrypt(password);
    const abc=process.env.REACT_APP_API_URL;
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/web-user/signIn`, { username: encryptedUsername, password: encryptedPassword });

    return res.data as AuthUserAPIResponse;
  } catch (error) {
    throw error;
  }
};

/* do not re throw error, as token might have expired while calling the API which will cause the sign-out API to fail. */
export const signOutAPI = async () => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/web-user/signOut`);
    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};

export const resetPasswordByAdmin = async (newPassword: string, resetPwdUserId: number) => {
  const encryptedNewPassword = RSAEncryption.encrypt(newPassword);
  try {
    const res = await axios.patch(`${process.env.REACT_APP_API_URL}/web-user/reset-password-by-admin`, { id: resetPwdUserId, newPassword: encryptedNewPassword });
    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};

export const updatedPasswordAPI = async (newPassword: string) => {
  const encryptedNewPassword = RSAEncryption.encrypt(newPassword);
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/web-user/updatePassword`, { newPassword: encryptedNewPassword });
    return response.data as AuthUserAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const requestResetPasswordAPI = async (username: string) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/web-user/request-password-reset`, { username });
    return response.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};

export const refreshTokenAPI = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/web-user/refresh`, {});
    return response.data as RefreshTokenAPIInterface;
  } catch (error) {
    throw error;
  }
};
